export const PLAN_LIMITS = {
  free: {
    personalVerticals: 2,
    joinedVerticals: 5,
    invitedUsers: 10,
    basicEditors: 0,
    advancedEditors: 0,
    verticalReplacementsPerCycle: 1,
    refreshesPerCycle: 2,
  },
  paid: {
    personalVerticals: 5,
    joinedVerticals: Infinity,
    invitedUsers: Infinity,
    basicEditors: Infinity,
    advancedEditors: Infinity,
    verticalReplacementsPerCycle: 3,
    refreshesPerCycle: 6,
  },
};

export const getPlanTier = (subscriptionStatus) =>
  subscriptionStatus === 'active' || subscriptionStatus === 'trialing' ? 'paid' : 'free';

export const getPlanLimits = (subscriptionStatus) => PLAN_LIMITS[getPlanTier(subscriptionStatus)];

export const getPersonalVerticalsLimit = (subscriptionStatus) =>
  getPlanLimits(subscriptionStatus).personalVerticals;

export const getJoinedVerticalsLimit = (subscriptionStatus) =>
  getPlanLimits(subscriptionStatus).joinedVerticals;

export const getInvitedUsersLimit = (subscriptionStatus) =>
  getPlanLimits(subscriptionStatus).invitedUsers;

export const getBasicEditorsLimit = (subscriptionStatus) =>
  getPlanLimits(subscriptionStatus).basicEditors;

export const getAdvancedEditorsLimit = (subscriptionStatus) =>
  getPlanLimits(subscriptionStatus).advancedEditors;

export const getVerticalReplacementsLimit = (subscriptionStatus) =>
  getPlanLimits(subscriptionStatus).verticalReplacementsPerCycle;

export const getRefreshesLimit = (subscriptionStatus) =>
  getPlanLimits(subscriptionStatus).refreshesPerCycle;
